import { VendorView } from '../../../types/entity-types';
import { hasVendorTransactionsInTimeframe } from './has-vendor-transactions-in-timeframe';

type GetVendorsWithTransactionsInTimeframeArgs = {
  vendors: VendorView[];
  startDate: Date;
  endDate: Date;
};

export const getVendorsWithTransactionsInTimeframe = ({
  vendors,
  startDate,
  endDate,
}: GetVendorsWithTransactionsInTimeframeArgs) => {
  return vendors.filter((v) => hasVendorTransactionsInTimeframe({ vendor: v, startDate, endDate }));
};
